

























import Vue from "vue";
import { ref, Ref } from "@vue/composition-api";
import { useHero } from "./hero.state";
export default Vue.extend({
  setup() {
    const container: Ref<HTMLDivElement | null> = ref(null);
    const isShow = ref(false);
    const { setRootListener } = useHero;
    const cmp = ref(null);
    const asHeroData = ref(null);
    const asHtml = ref(false);
    let fromHtml: HTMLElement | null = null;

    const hide = async () => {
      isShow.value = false;
      fromHtml && (fromHtml.style.opacity = "1");
    };

    setRootListener({
      onShowHtml: async (payload) => {
        asHtml.value = true;
        isShow.value = true;
        cmp.value = null;
        asHeroData.value = null;
        fromHtml = payload.html;
        setTimeout(() => {
          if (container.value) {
            container.value.appendChild(payload.html.cloneNode(true));
            payload.html.style.opacity = "0";
          }
        }, 0);
      },
      onShowCmp: async (payload) => {
        asHtml.value = false;
        asHeroData.value = payload.data;
        cmp.value = payload.cmp;
        isShow.value = true;
        fromHtml = payload.html;
        setTimeout(() => {
          if (container.value) {
            payload.html.style.opacity = "0";
          }
        }, 0);
      },
      onHide: hide,
    });

    return {
      asHtml,
      container,
      isShow,
      hide,
      cmp,
      asHeroData,
    };
  },
});
